// extracted by mini-css-extract-plugin
export var iframContainer = "whatIsEpiscopal-module--iframContainer--011b1";
export var main = "whatIsEpiscopal-module--main--5c14d";
export var videoContainer = "whatIsEpiscopal-module--videoContainer--9f715";